import {
  clearStableRequest,
  getBrowserStorage,
  getOrCreateStableRequest,
} from '../../../../services/stableRequestId'
import {
  REMOTE_SENSING_LAYERS,
  normalizeRemoteSensingSource,
} from '../Images/remoteSensingModel'

const REQUEST_PREFIX = 'specific:image-ambient-hd'

export const IMAGE_AMBIENT_HD_BASES = {
  MULTIBAND: 'multiband',
  NDVI: 'ndvi',
  EVI: 'evi',
  NDRE: 'ndre',
}

export const getImageAmbientHdBasis = (source) => {
  const {layer} = normalizeRemoteSensingSource(source)
  if (layer === REMOTE_SENSING_LAYERS.VISIBLE) {
    return IMAGE_AMBIENT_HD_BASES.MULTIBAND
  }

  return Object.values(IMAGE_AMBIENT_HD_BASES).includes(layer)
    ? layer
    : IMAGE_AMBIENT_HD_BASES.MULTIBAND
}

const getSessionStorage = () => getBrowserStorage('sessionStorage')

export const getOrCreateImageAmbientHdRequest = (
  {acquisitionId, basis, landId, numClasses},
  storage = getSessionStorage(),
  createId
) => getOrCreateStableRequest(
  REQUEST_PREFIX,
  {acquisitionId, basis, landId, numClasses: Number(numClasses)},
  storage,
  createId
)

export const clearImageAmbientHdRequest = (
  storageKey,
  storage = getSessionStorage()
) => clearStableRequest(storageKey, storage)

export const buildImageAmbientHdPayload = ({
  acquisitionId,
  basis,
  idempotencyKey,
  numClasses,
}) => ({
  acquisition_id: acquisitionId,
  basis,
  num_classes: Number(numClasses),
  ...(idempotencyKey
    ? {request_id: idempotencyKey, idempotency_key: idempotencyKey}
    : {}),
})
